import React from 'react';
import './Home.css';
import { getHomedata } from '../../api';
import { useEffect, useState } from 'react';
import Hearde from './Hearde/Hearde'
import Navlist from './Navlist/Navlist';
import { Carousel } from 'antd';
import Footer from './Footer/Footer';
import { insert_adv, remove_adv } from '../../method/addadv';
import Share from './Share/Share';
import { iframeLoad } from '../../method/analytics';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css'
import "swiper/css/pagination";


export default function Home() {
    const [dataArray, setDataArray] = useState({ cate: [], hotgame: [], newgame: [], populgame: [] });

    const getdata = () => {
        getHomedata().then(res => {
            // console.log(res);
            setDataArray({
                cate: res.data.category,
                hotgame: res.data.hotgames,
                newgame: res.data.newgames,
                populgame: res.data.populargames
            });

            /**
             * 解決swiper組件 因爲圖片為加載未完成導致計算錯誤引發的滑動問題
             * 解決方法渲染完成以後重新刷新swiper組件
             * 使用swiper组件 是因为chrome55版本又兼容问题
             */

            /**
             * 解决chrome52版本的兼容问题
             */

            setSwiperflag(false)
            setTimeout(function(){
                setSwiperflag(true);
            }, 800);
        })
    }


    // 跳转详情
    const goDetails = (para) => {
        window.location = "/page/details?gid=" + para;
    }

    /* 左上角导航控制 */
    const [flag, setFlag] = useState(false)
    const top_list = () => {
        setFlag(flag == false ? true : false)
    }

    // 判断view是否可以滚动
    flag ? document.getElementsByTagName("body")[0].style.overflow = 'hidden' : document.getElementsByTagName("body")[0].style.overflow = 'hidden auto';

    const setflag = () => {
        setFlag(false)
    }
    /* 搜索栏 */
    const [searflag, setSearchflag] = useState(false)
    const setsear = () => {
        setSearchflag(true)
    }
    /* 关闭搜索栏 */
    const setSearch = () => {
        setSearchflag(false)
    }

    /* 分享控制 */
    const [share, setShare] = useState(false)
    const setshare = () => {
        share ? setShare(false) : setShare(true)
    }

    const [swiperflag, setSwiperflag] = useState(false)

    useEffect(() => {
        getdata();

        if (window.law_ntv_ad1, window.law_ntv_ad2) {
            insert_adv("adv_1");
            insert_adv("adv_2");
            // 广告加载 上传分析
            var pageLoadSecond = new Date().getTime();
            iframeLoad(pageLoadSecond);

            return () => {
                remove_adv('adv_1');
                remove_adv('adv_2');
            }
        }
    }, [])

    return (
        <div className='home_3'>
            {/* head */}
            <Hearde top_list={top_list} setsear={setsear} searflag={searflag} setSearch={setSearch} flag={flag} setshare={setshare}></Hearde>

            <Navlist flag={flag} setflag={setflag} gamecata={dataArray.cate}></Navlist>
            <Share flag={share} setshare={setshare}></Share>


            <section className='main_section'>

                {/* populargames */}
                <div className='home3_popu'>
                    <h1>Popular Games</h1>

                    {
                        swiperflag
                            ? <Swiper
                                className='ant-carousel'
                                modules={[Autoplay, Pagination]}
                                loop={true}
                                autoplay={
                                    {
                                        delay: 3000,
                                        disableOnInteraction: false,
                                    }
                                }
                                pagination={true} >
                                {dataArray.populgame.map(item => (
                                    <SwiperSlide key={item.gid}>
                                        <div className='banner_con'>
                                            <a href={"/page/details?gid=" + item.gid} className='dis_a'>
                                                <img src={process.env.REACT_APP_BASEURL + item.icon} alt="" />
                                                <p>{item.name}</p>
                                            </a>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                            : ''
                    }

                    {/*<Carousel autoplay>*/}
                    {/*    {dataArray.populgame.map(item => (*/}
                    {/*        <div key={item.gid} className='banner_con' >*/}
                    {/*            <a href={"/page/details?gid=" + item.gid} className='dis_a'>*/}
                    {/*                <img src={process.env.REACT_APP_BASEURL + item.icon} alt="" />*/}
                    {/*                <p>{item.name}</p>*/}
                    {/*            </a>*/}
                    {/*        </div>*/}
                    {/*    ))}*/}
                    {/*</Carousel>*/}

                </div>

                {/* 广告一 */}
                <div className='adv_box'>
                    <p>Advertisement</p>
                    <div id='adv_1' dangerouslySetInnerHTML={{ __html: window.law_ntv_ad1 }}></div>
                </div>

                {/* hotgames */}
                <div className='home3_hot'>
                    <h1>Hot Games</h1>
                    <ul>
                        {dataArray.hotgame.map(item => (
                            <li key={item.gid} >
                                <a href={"/page/details?gid=" + item.gid} className='dis_a'>
                                    <img src={process.env.REACT_APP_BASEURL + item.icon} width="320" height="320" alt="" />
                                    <p>{item.name}</p>
                                </a>

                            </li>
                        ))}
                    </ul>
                </div>

                {/* 广告二 */}
                <div className='adv_box'>
                    <p>Advertisement</p>
                    <div id='adv_2' dangerouslySetInnerHTML={{ __html: window.law_ntv_ad2 }}></div>
                </div>

                {/* newgames */}
                <div className='home3_new'>
                    <h1>New Games</h1>
                    <ul>
                        {dataArray.newgame.map(item => (
                            <li key={item.gid} >
                                <a href={"/page/details?gid=" + item.gid} className='dis_a'>
                                    <img src={process.env.REACT_APP_BASEURL + item.icon} width="320" height="320" alt="" className='game_icon' />
                                </a>

                            </li>
                        ))}
                    </ul>
                </div>

            </section>

            {/* foot */}
            <Footer></Footer>

        </div>
    )
}
